import React, { useState } from 'react';
import { VerificationScreenContainer } from '../../components/modalOtpUniversia/components/verificationScreenContainer';
import { ModalOtpUniversiaContainer } from '../../components/modalOtpUniversia/modalOtpUniversiaContainer';
import { InitialView } from './InitialViewContainer';

function InitialViewWithModal() {
    const [toggleSnackBar, setToggleSnackBar] = useState(false);

    return (
        <>
            <InitialView />
            <ModalOtpUniversiaContainer toggleSnackBar={toggleSnackBar}>
                <VerificationScreenContainer setToggleSnackBar={setToggleSnackBar} />
            </ModalOtpUniversiaContainer>
        </>
    );
}

export default InitialViewWithModal;
